<template lang="pug">
.new-code
  shForm(title="Nuevo Código")
</template>

<script>
import shForm from '@/components/pages/code/Form'

export default {
  name: 'NewCode',

  components: { shForm }
}
</script>

<style lang="stylus">
.new-code
  position relative
</style>



// WEBPACK FOOTER //
// src/components/pages/code/New.vue